import stoolType1Img from '@/assets/stool/type1.svg'
import stoolType2Img from '@/assets/stool/type2.svg'
import stoolType3Img from '@/assets/stool/type3.svg'
import stoolType4Img from '@/assets/stool/type4.svg'
import stoolType5Img from '@/assets/stool/type5.svg'
import stoolType6Img from '@/assets/stool/type6.svg'
import stoolType7Img from '@/assets/stool/type7.svg'

const genderOptions = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
];

const ethnicityOptions = [
  {
    label: "American Indian or Alaska Native",
    value: "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
  },
  {
    label: "Native Hawaiian or Other Pacific Islander",
    value: "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER",
  },
  {
    label: "Hispanic/Latino",
    value: "HISPANIC_LATINO",
  },
  {
    label: "White(e.g., European, Middle Eastern, North African descent)",
    value: "WHITE",
  },
  {
    label: "Asian(e.g., Chinese, Indian, Filipino, Vietnamese, Korean, Japanese, etc.)",
    value: "ASIAN",
  },
  {
    label: "Black or African American",
    value: "BLACK_OR_AFRICAN_AMERICAN",
  },
  {
    label: "Two or more races/ethnicities",
    value: "TWO_OR_MORE_RACES_ETHNICITIES",
  },
  {
    label: "Prefer not to say",
    value: "PREFER_NOT_TO_SAY",
  },
  {
    label: "Other",
    value: "OTHER",
  }];

const yesNoOptions = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

const hysterectomyOptions = [
  {
    label: "Yes- Total",
    value: "TOTAL_HYSTERECTOMY",
  },
  {
    label: "Yes- Partial",
    value: "PARTIAL_HYSTERECTOMY",
  },
  {
    label: "No",
    value: "NO",
  },
];

const ovariesRemovedOptions = [
  {
    label: "Both Ovaries",
    value: "BOTH",
  },
  {
    label: "One Ovary",
    value: "ONE",
  },
  {
    label: "None",
    value: "NO",
  },
];

const menstrualCyclePhaseOptions = [
  {
    label: "Luteal Phase (Days 15 – 28)",
    value: "LUTEAL",
  },
  {
    label: "Follicular Phase (Days 6 – 14)",
    value: "FOLLICULAR",
  },
  {
    label: "Ovulatory Phase (Days 14 – 15) ",
    value: "OVULATORY",
  },
  {
    label: "Pre-puberty (has not had 1st period) ",
    value: "PRE_PUBERTY",
  },
  {
    label:
      "Unable to select Phase due to irregular cycle(s), for less than 1 year, for any reason",
    value: "UNABLE_TO_SELECT",
  },
  {
    label: "No menstrual cycles for greater than 1 year, for any reason",
    value: "NO_MENSTRUAL_CYCLES",
  },
];

const reproductiveHealthStageOptions = [
  {
    label: "Premenopausal Phase(regularly menstruating every 21-35 days) ",
    value: "PREMENOPAUSAL_PHASE",

  },
  {
    label:
      "Perimenopausal, or irregular menstruation for less than 1 year, for any reason",
    value: "PERIMENOPAUSAL_PHASE",
  },
  {
    label: "Postmenopausal, or no menstruation for greater than 1 year, for any reason",
    value: "POSTMENOPAUSAL_PHASE",
  },
  {
    label: "Pregnant",
    value: "PREGNANT",
  },
  {
    label: "Pre-puberty (age 15 or older), has not had first period",
    value: "PRE_PUBERTY",
  },
];

const premenopausalPhaseResultOptions = [
  {
    label: "Follicular(Days 6–14)",
    value: "FOLLICULAR",
  },
  {
    label: "Ovulation(Days 14–15)",
    value: "OVULATORY",
  },
  {
    label: "Luteal(Days 15–28)",
    value: "LUTEAL",
  },
];

const yesNoUnsureOptions = [
  {
    label: "Yes",
    value: "YES",
  },
  {
    label: "No",
    value: "NO",
  },
  {
    label: "Unsure",
    value: "UNSURE",
  },
];

const HRTOptions = [
  {
    label: "HRT",
    value: "HRT",
  },
  {
    label: "Non-HRT",
    value: "NON_HRT",
  },
  {
    label: "Unsure",
    value: "UNSURE",
  },
];

const severityOptions = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
];

const frequencyOptions = [
  {
    label: "0",
    value: 4,
  },
  {
    label: "1",
    value: 5,
  },
  {
    label: "2",
    value: 6,
  },
  {
    label: "3",
    value: 7,
  },
];

const femaleDiseaseHistoryOptions = [
  {
    label: "Breast cancer",
    value: "breast_cancer",
  },
  {
    label: "Ovarian cancer",
    value: "ovarian_cancer",
  },
  {
    label: "Endometrial(uterine) cancer",
    value: "endometrial_cancer",
  },
  {
    label: "Stomach cancer",
    value: "stomach_cancer",
  },
  {
    label: "Pancreatic cancer",
    value: "pancreatic_cancer",
  },
  {
    label: "Colon or rectal cancer",
    value: "colon_rectal_cancer",
  },
  {
    label: "Any other condition not listed above",
    value: "other",
  },
];

const femaleComorbidityOptions = [
  {
    label: "Cardiovascular disease",
    value: "cardiovascular_disease",
  },
  {
    label: "Type 2 diabetes",
    value: "type2_diabetes",
  },
  {
    label: "Hypertension",
    value: "hypertension",
  },
  {
    label: "Obesity",
    value: "obesity",
  },
  {
    label: "Thyroid conditions",
    value: "thyroid_conditions",
  },
  {
    label: "Liver disease",
    value: "liver_disease",
  },
  {
    label: "Gallbladder complications",
    value: "gallbladder_complications",
  },
  {
    label:
      "Blood clots or venous thromboembolism (e.g., deep vein thrombosis, pulmonary embolism)",
    value: "blood_clots",
  },
  {
    label: "Other",
    value: "other",
  },
];

const femaleFamilyHistoryOptions = [
  {
    label: "Cancer",
    value: "family_cancer_history",
  },
  {
    label: "Breast cancer",
    value: "family_breast_cancer",
  },
  {
    label: "Hypertension",
    value: "family_hypertension",
  },
  {
    label: "Cardiovascular disease",
    value: "family_cardio_disease",
  },
  {
    label: "Cerebrovascular disease",
    value: "family_cerebrovascular",
  },
  {
    label: "SLE or Autoimmune",
    value: "family_autoimmune",
  },
  {
    label: "Venous thrombus embolism",
    value: "family_venous_thrombus",
  },
  {
    label: "Thyroid disease",
    value: "family_thyroid_disease",
  },
  {
    label: "Other",
    value: "other",
  },
];

const maleFamilyHistoryOptions = [
  {
    label: "Cancer",
    value: "family_cancer_history",
  },
  {
    label: "Prostate cancer/issues",
    value: "family_prostate_cancer",
  },
  {
    label: "Hypertension",
    value: "family_hypertension",
  },
  {
    label: "Cardiovascular disease",
    value: "family_cardio_disease",
  },
  {
    label: "Cerebrovascular disease",
    value: "family_cerebrovascular",
  },
  {
    label: "SLE or Autoimmune",
    value: "family_autoimmune",
  },
  {
    label: "Venous thrombus embolism",
    value: "family_venous_thrombus",
  },
  {
    label: "Thyroid disease",
    value: "family_thyroid_disease",
  },
  {
    label: "Other",
    value: "other",
  },
];

const maleDiseaseHistoryOptions = [
  {
    label: "Type 2 diabetes",
    value: "type2_diabetes",
  },
  {
    label: "Liver disease",
    value: "liver_disease",
  },
  {
    label: "Sleep apnea",
    value: "sleep_apnea",
  },
  {
    label: "SLE or Autoimmune",
    value: "autoimmune_conditions",
  },
  {
    label: "Infertility issues",
    value: "infertility_issues",
  },
  {
    label: "Obesity",
    value: "obesity",
  },
  {
    label: "Cardiovascular disease (heart attack, stroke, etc.)",
    value: "cardiovascular_disease",
  },
  {
    label: "Prostate conditions (e.g., BPH, prostate cancer)",
    value: "prostate_conditions",
  },
  {
    label: "Thyroid disease",
    value: "thyroid_conditions",
  },
  {
    label: "Hypertension",
    value: "hypertension",
  },
  {
    label: "Other",
    value: "other",
  },
];

const gutRelatedConditionOptions = [
  {
    label: "Irritable Bowel Syndrome (IBS)",
    value: "personal_ibs",
  },
  {
    label: "Inflammatory Bowel Disease (IBD)",
    value: "personal_ibd",
  },
  {
    label: "Celiac Disease",
    value: "personal_celiac_disease",
  },
  {
    label: "Small Intestinal Bacterial Overgrowth (SIBO)",
    value: "personal_sibo",
  },
  {
    label: "Food allergies / intolerances / sensitivity",
    value: "personal_food_allergies",
  },
  {
    label: "Other",
    value: "other",
  },
];

const gutRelatedFamilyHistoryOptions = [
  {
    label: "Irritable Bowel Syndrome (IBS)",
    value: "family_ibs",
  },
  {
    label: "Inflammatory Bowel Disease (IBD)",
    value: "family_ibd",
  },
  {
    label: "Celiac Disease",
    value: "family_celiac_disease",
  },
  {
    label: "Small Intestinal Bacterial Overgrowth (SIBO)",
    value: "family_sibo",
  },
  {
    label: "Food allergies / intolerances / sensitivity",
    value: "family_food_allergies",
  },
  {
    label: "Other",
    value: "other",
  },
];

const cardioRelatedConditionOptions = [
  {
    label: "Cardiovascular disease (e.g., heart attack, stroke)",
    value: "personal_cardiovascular_disease",
  },
  {
    label: "High blood pressure",
    value: "personal_high_blood_pressure",
  },
  {
    label: "High cholesterol",
    value: "personal_high_cholesterol",
  },
  {
    label: "Atherosclerosis",
    value: "personal_atherosclerosis",
  },
  {
    label: "Peripheral arterial disease",
    value: "personal_peripheral_arterial_disease",
  },
  {
    label: "Diabetes",
    value: "personal_diabetes",
  },
  {
    label: "Insulin resistance",
    value: "personal_insulin_resistance",
  },
  {
    label: "Kidney disease",
    value: "personal_kidney_disease",
  },
  {
    label: "Liver disease",
    value: "personal_liver_disease",
  },
  {
    label: "Other",
    value: "other",
  },
];

const cardioRelatedFamilyHistoryOptions = [
  {
    label: "Cardiovascular disease (e.g., heart attack, stroke)",
    value: "family_cardiovascular_disease",
  },
  {
    label: "High blood pressure",
    value: "family_high_blood_pressure",
  },
  {
    label: "High cholesterol",
    value: "family_high_cholesterol",
  },
  {
    label: "Atherosclerosis",
    value: "family_atherosclerosis",
  },
  {
    label: "Peripheral arterial disease",
    value: "family_peripheral_arterial_disease",
  },
  {
    label: "Diabetes",
    value: "family_diabetes",
  },
  {
    label: "Insulin resistance",
    value: "family_insulin_resistance",
  },
  {
    label: "Kidney disease",
    value: "family_kidney_disease",
  },
  {
    label: "Liver disease",
    value: "family_liver_disease",
  },
  {
    label: "Other",
    value: "other",
  },
];

const cardioPhysicalActivityTypeOptions = [
  {
    label: "Aerobic/cardio (e.g., brisk walking, jogging, cycling, swimming, hiking, stair climbing)",
    value: "aerobic_exercise",
  },
  {
    label: "Resistance/strength training (e.g., weight training, resistance bands, yoga, Pilates)",
    value: "strength_training",
  },
  {
    label: "Balance training (e.g., Tai Chi, yoga, single-leg stands, squats, balance boards)",
    value: "balance_training",
  },
];

const boneDensityScanOptions = [
  {
    label: "Normal",
    value: "NORMAL",
  },
  {
    label: "Osteopenia",
    value: "OSTEOPENIA",
  },
  {
    label: "Osteoporosis",
    value: "OSTEOPOROSIS",
  },
  {
    label: "Don't know",
    value: "UNKNOWN",
  },
];

const activeOptions = [
  {
    label: "Sedentary (<30 mins exercise per day)",
    value: "SEDENTARY",
  },
  {
    label: "Moderately Active (30-60 mins exercise per day)",
    value: "MODERATELY_ACTIVE",
  },
  {
    label: "Highly active (>60 mins exercise per day)",
    value: "HIGHLY_ACTIVE",
  },
];

const sleepHoursOptions = [
  {
    label: "> 8 hours",
    value: "MORE_THAN_8_HOURS",
  },
  {
    label: "5-8 hours",
    value: "BETWEEN_5_AND_8_HOURS",
  },
  {
    label: "< 5 hours",
    value: "LESS_THAN_5_HOURS",
  },
];

const tabaccoUseOptions = [
  {
    label: "Yes, regularly",
    value: "YES_REGULARLY",
  },
  {
    label: "Yes, occasionally",
    value: "YES_OCCASIONALLY",
  },
  {
    label: "No",
    value: "NO",
  },
];

const alcoholUseOptions = [
  {
    label: "Never",
    value: "NEVER",
  },
  {
    label: "Monthly or less",
    value: "MONTHLY_OR_LESS",
  },
  {
    label: "2-4 times a month",
    value: "TWO_TO_FOUR_TIMES_A_MONTH",
  },
  {
    label: "2-3 times a week",
    value: "TWO_TO_THREE_TIMES_A_WEEK",
  },
  {
    label: "4 or more times a week",
    value: "FOUR_OR_MORE_TIMES_A_WEEK",
  },
];

const stressLevelOptions = [
  {
    label: "Low",
    value: "LOW",
  },
  {
    label: "Moderate",
    value: "MODERATE",
  },
  {
    label: "High",
    value: "HIGH",
  },
];

const stressReductionOptions = [
  {
    label: "Never",
    value: "NEVER",
  },
  {
    label: "Rarely(a few times per month)",
    value: "RARELY",
  },
  {
    label: "Occasionally(1-2 times per week)",
    value: "OCCASIONALLY",
  },
  {
    label: "Frequently(3-4 times per week)",
    value: "FREQUENTLY",
  },
  {
    label: "Daily or almost daily",
    value: "DAILY_OR_ALMOST_DAILY",
  },
];

const antibioticsHistoryOptions = [
  {
    label: "< 1 month ago",
    value: "LESS_THAN_1_MONTH",
  },
  {
    label: "1-3 months ago",
    value: "ONE_TO_THREE_MONTHS",
  },
  {
    label: "> 3 months ago",
    value: "MORE_THAN_3_MONTHS",
  },
];

const stoolOptions = [
  {
    value: 'TYPE_1',
    image: stoolType1Img,
    title: 'Type 1',
    label: 'Separate hard lumps',
  },
  {
    value: 'TYPE_2',
    image: stoolType2Img,
    title: 'Type 2',
    label: 'Sausage-shaped, but lumpy',
  },
  {
    value: 'TYPE_3',
    image: stoolType3Img,
    title: 'Type 3',
    label: 'Like a sausage but with cracks on its surface',
  },
  {
    value: 'TYPE_4',
    image: stoolType4Img,
    title: 'Type 4',
    label: 'Like a sausage or snake, smooth and soft',
  },
  {
    value: 'TYPE_5',
    image: stoolType5Img,
    title: 'Type 5',
    label: 'Soft blobs with clear-cut edges',
  },
  {
    value: 'TYPE_6',
    image: stoolType6Img,
    title: 'Type 6',
    label: 'Fluffy pieces with ragged edges, a mushy stool',
  },
  {
    value: 'TYPE_7',
    image: stoolType7Img,
    title: 'Type 7',
    label: 'Watery, no solid pieces. Entirely liquid.',
  }
];

const bowelMovementOptions = [
  {
    label: "Less than 3 times per week",
    value: "LESS_THAN_3_PER_WEEK",
  },
  {
    label: "3-7 times per week",
    value: "THREE_TO_SEVEN_PER_WEEK",
  },
  {
    label: "More than 7 times per week",
    value: "MORE_THAN_7_PER_WEEK",
  },
];

const cardioPhysicalActivityFrequencyOptions = [
  {
    label: "0 - 1 time per week",
    value: "ONE_OR_LESS_PER_WEEK",
  },
  {
    label: "2 times per week",
    value: "TWO_PER_WEEK",
  },
  {
    label: "3-4 times per week",
    value: "THREE_TO_FOUR_PER_WEEK",
  },
  {
    label: "5-7 times per week",
    value: "FIVE_TO_SEVEN_PER_WEEK",
  },
];

const cardioSleepHoursOptions = [
  {
    label: "< 5 hours",
    value: "LESS_THAN_FIVE_HOURS",
  },
  {
    label: "6 hours",
    value: "SIX_HOURS",
  },
  {
    label: "7 - 9 hour",
    value: "SEVEN_TO_NINE_HOURS",
  },
];

const cardioAlcoholicDrinkingOptions = [
  {
    label: "Never(0 drinks per month)",
    value: "NEVER",
  },
  {
    label: "1-3 drinks per month",
    value: "ONE_TO_THREE_PER_MONTH",
  },
  {
    label: "4-8 drinks per month (about 1-2 per week)",
    value: "FOUR_TO_EIGHT_PER_MONTH",
  },
  {
    label: "9-15 drinks per month (about 2-3 per week)",
    value: "NINE_TO_FIFTEEN_PER_MONTH",
  },
  {
    label: "16-30 drinks per month (about 4-7 per week)",
    value: "SIXTEEN_TO_THIRTY_PER_MONTH",
  },
  {
    label: "More than 30 drinks per month (8+ per week)",
    value: "MORE_THAN_THIRTY_PER_MONTH",
  },
];

export {
  genderOptions,
  ethnicityOptions,
  yesNoOptions,
  hysterectomyOptions,
  ovariesRemovedOptions,
  menstrualCyclePhaseOptions,
  reproductiveHealthStageOptions,
  yesNoUnsureOptions,
  HRTOptions,
  severityOptions,
  frequencyOptions,
  femaleDiseaseHistoryOptions,
  femaleComorbidityOptions,
  femaleFamilyHistoryOptions,
  maleFamilyHistoryOptions,
  maleDiseaseHistoryOptions,
  boneDensityScanOptions,
  premenopausalPhaseResultOptions,
  activeOptions,
  sleepHoursOptions,
  tabaccoUseOptions,
  alcoholUseOptions,
  stressLevelOptions,
  stressReductionOptions,
  antibioticsHistoryOptions,
  gutRelatedConditionOptions,
  gutRelatedFamilyHistoryOptions,
  cardioRelatedConditionOptions,
  cardioRelatedFamilyHistoryOptions,
  cardioPhysicalActivityFrequencyOptions,
  cardioPhysicalActivityTypeOptions,
  cardioSleepHoursOptions,
  cardioAlcoholicDrinkingOptions,
  stoolOptions,
  bowelMovementOptions,
};
